import { motion } from "framer-motion";
import {
    Users,
    ShieldCheck,
    ShoppingBag,
    ExternalLink,
    Sparkles,
    ChevronRight
} from "lucide-react";

export default function CommunitySidebar({

    community,

    stats,

    products = [],

    onOpenProduct,

    onOpenRules

}) {

    return (

        <motion.aside

            initial={{ opacity: 0, x: -20 }}

            animate={{ opacity: 1, x: 0 }}

            className="
                sticky
                top-24
                space-y-6
            "

        >

            {/* About */}

            <GlassCard>

                <h3 className="font-bold text-xl">

                    About

                </h3>

                <p className="mt-4 text-gray-600 leading-7">

                    {community.description}

                </p>

            </GlassCard>

            {/* Statistics */}

            <GlassCard>

                <h3 className="font-bold">

                    Community Stats

                </h3>

                <div className="space-y-5 mt-5">

                    <Stat

                        icon={<Users size={18}/>}

                        label="Members"

                        value={stats.members}

                    />

                    <Stat

                        icon={<Sparkles size={18}/>}

                        label="Threads"

                        value={stats.posts}

                    />

                    <Stat

                        icon={<ShieldCheck size={18}/>}

                        label="Online"

                        value={stats.online}

                    />

                </div>

            </GlassCard>

            {/* Rules */}

            <GlassCard>

                <div className="flex items-center justify-between">

                    <h3 className="font-bold">

                        Community Rules

                    </h3>

                    <button

                        onClick={onOpenRules}

                    >

                        <ExternalLink size={18}/>

                    </button>

                </div>

                <ul className="mt-5 space-y-3 text-gray-600">

                    <li>• Be respectful.</li>

                    <li>• Stay on topic.</li>

                    <li>• No spam.</li>

                    <li>• Constructive discussions only.</li>

                    <li>• Support fellow creators.</li>

                </ul>

            </GlassCard>

            {/* Featured Products */}

            {

                products.length > 0 && (

                    <GlassCard>

                        <div className="flex justify-between">

                            <h3 className="font-bold">

                                Featured Products

                            </h3>

                            <ShoppingBag size={18}/>

                        </div>

                        <div className="mt-5 space-y-4">

                            {

                                products.slice(0,3).map(product=>(

                                    <button

                                        key={product.id}

                                        onClick={()=>onOpenProduct(product)}

                                        className="
                                            w-full
                                            flex
                                            items-center
                                            gap-4
                                            text-left
                                            hover:bg-gray-50
                                            rounded-2xl
                                            p-2
                                            transition
                                        "

                                    >

                                        <img

                                            src={product.image}

                                            alt=""

                                            className="
                                                w-14
                                                h-14
                                                rounded-xl
                                                object-cover
                                            "

                                        />

                                        <div className="flex-1">

                                            <div className="font-semibold">

                                                {product.name}

                                            </div>

                                            <div className="text-sm text-gray-500">

                                                ₹{product.price}

                                            </div>

                                        </div>

                                        <ChevronRight size={18}/>

                                    </button>

                                ))

                            }

                        </div>

                    </GlassCard>

                )

            }

            {/* Quick Links */}

            <GlassCard>

                <h3 className="font-bold">

                    Quick Links

                </h3>

                <div className="mt-5 space-y-3">

                    <LinkButton>

                        Community Events

                    </LinkButton>

                    <LinkButton>

                        Leaderboard

                    </LinkButton>

                    <LinkButton>

                        Members

                    </LinkButton>

                    <LinkButton>

                        CreatiStyle Collection

                    </LinkButton>

                </div>

            </GlassCard>

        </motion.aside>

    );

}

function GlassCard({ children }){

    return(

        <div
            className="
                rounded-[28px]
                bg-white/70
                backdrop-blur-xl
                border
                border-white/30
                shadow-xl
                p-6
            "
        >

            {children}

        </div>

    );

}

function Stat({

    icon,

    label,

    value

}){

    return(

        <div className="flex justify-between">

            <div className="flex gap-3 items-center">

                <div className="text-blue-600">

                    {icon}

                </div>

                <span>

                    {label}

                </span>

            </div>

            <span className="font-semibold">

                {value}

            </span>

        </div>

    );

}

function LinkButton({ children }){

    return(

        <button
            className="
                w-full
                flex
                justify-between
                items-center
                rounded-2xl
                p-3
                hover:bg-gray-100
                transition
            "
        >

            <span>

                {children}

            </span>

            <ChevronRight size={18}/>

        </button>

    );

}